var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 21.834,
    height: 25,
    fill: "white",
    stroke: "#285FCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58691,
    y: 4.12891,
    width: 16.6957,
    height: 1.04348,
    fill: "#285FCB",
    fillOpacity: 0.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58691,
    y: 8.30469,
    width: 16.6957,
    height: 1.04348,
    fill: "#285FCB",
    fillOpacity: 0.15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58691,
    y: 12.4766,
    width: 16.6957,
    height: 1.04348,
    fill: "#285FCB",
    fillOpacity: 0.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58691,
    y: 16.6523,
    width: 16.6957,
    height: 1.04348,
    fill: "#285FCB",
    fillOpacity: 0.15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58691,
    y: 20.8242,
    width: 12.5217,
    height: 1.04348,
    fill: "#285FCB",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4508 5.31325C11.6949 4.89558 12.3051 4.89558 12.5492 5.31325L19.4141 17.0602C19.6582 17.4779 19.3531 18 18.8649 18H5.1351C4.64693 18 4.34182 17.4779 4.58591 17.0602L11.4508 5.31325Z",
    fill: "#EC0202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6375 9.86032L12.5047 13.8809H11.5386L11.4017 9.86032H12.6375ZM11.3695 15.1257C11.3695 14.956 11.4285 14.8155 11.5466 14.7041C11.6674 14.5901 11.8257 14.5331 12.0216 14.5331C12.2202 14.5331 12.3785 14.5901 12.4966 14.7041C12.6147 14.8155 12.6737 14.956 12.6737 15.1257C12.6737 15.29 12.6147 15.4292 12.4966 15.5432C12.3785 15.6572 12.2202 15.7142 12.0216 15.7142C11.8257 15.7142 11.6674 15.6572 11.5466 15.5432C11.4285 15.4292 11.3695 15.29 11.3695 15.1257Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileErrorIcon);
export default __webpack_public_path__ + "static/media/file-error-icon.2b2c6daf.svg";
export { ForwardRef as ReactComponent };